module.exports = __webpack_public_path__ + "img/no-image.aef671d5.png";